import {fetchApi, instance} from "../fetch";
import {API_HOST, API_URL} from "../../constants/axios";
import {EventSourcePolyfill} from "event-source-polyfill";


/** 날짜가 null 이면 기간 조건 없이 조회한다("전체" 탭). 키 자체를 빼야 한다 — volatility-message.api.js 참고. */
export const listAIMessages = async (startDate, endDate, page, size) => {
    const searchParam = new URLSearchParams({ page, size });
    if (startDate && endDate) {
        searchParam.set("startDate", startDate);
        searchParam.set("endDate", endDate);
    }
    const res = await fetchApi.get(API_URL.AI_MESSAGE_LIST + "?" + searchParam.toString())
    if (res.status === 200) {
        return res.data;
    } else {
        return [];
    }
}

export const getTextHistory = async (id) => {
    const res = await fetchApi.get(`${API_URL.AI_CHAT_DETAIL.replace("{id}", id)}`)
    if (res.status === 200) {
        return res.data;
    } else {
        return [];
    }
}

export const updateProducts = async (id, productIds) => {
    const res = await fetchApi.post(`${API_URL.AI_UPDATE_PRODUCTS.replace("{id}", id)}`, {
        productIds: productIds
    })
    if (res.status === 200) {
        return res.data;
    } else {
        return [];
    }
}

export const getAIMessage = async (id) => {
    const res = await fetchApi.get(`${API_URL.AI_MESSAGE_EDIT.replace("{id}", id)}`)
    if (res.status === 200) {
        return res.data;
    } else {
        return [];
    }
}

export const getAIDetailMessage = async (id) => {
    const res = await fetchApi.get(`${API_URL.AI_MESSAGE_DETAIL.replace("{id}", id)}`)
    if (res.status === 200) {
        return res.data;
    } else {
        return [];
    }
}

export const createAIMessage = async (isConnect) => {
    const res = await fetchApi.post(`${API_URL.AI_MESSAGE}?isConnect=${isConnect}`)
    if (res.status === 200) {
        return res.data;
    } else {
        return [];
    }
}

export const saveAIMessage = async (id, message) => {
    const res = await fetchApi.post(`${API_URL.AI_MESSAGE_EDIT.replace("{id}", id)}`, {
        campaignName: message.campaignName,
        objective: message.objective,
        detailObjective: message.detailObjective,
        messageData: message.messageData
    })
    if (res.status === 200) {
        return res.data;
    } else {
        return [];
    }
}

export const getVariantsAIMessage = async (id, variantsKey) => {
    const res = await fetchApi.get(`${API_URL.AI_MESSAGE_VARIANTS.replace("{id}", id)}?variantsKey=${variantsKey}`)
    if (res.status === 200) {
        return res.data;
    } else {
        return [];
    }
}

export const saveVariantsAIMessage = async (id, variantsKey) => {
    const res = await fetchApi.post(`${API_URL.AI_MESSAGE_VARIANTS.replace("{id}", id)}?variantsKey=${variantsKey}`)
    if (res.status === 200) {
        return res.data;
    } else {
        return [];
    }
}

export const changeVariantsStatus = async (id, variantsKey, status) => {
    const res = await fetchApi.post(`${API_URL.AI_MESSAGE_VARIANTS_STATUS.replace("{id}", id)}?variantsKey=${variantsKey}&status=${status}`)
    if (res.status === 200) {
        return res.data;
    } else {
        return [];
    }
}


export const addProduct = async (id, productId) => {
    const res = await fetchApi.post(`${API_URL.AI_ADD_PRODUCT.replace("{id}", id)}`, {
        productId: productId
    })
    if (res.status === 200) {
        return res.data;
    } else {
        return [];
    }
}

export const updateImage = async (id, blobs) => {
    const res = await fetchApi.multipart_post(`${API_URL.IMAGE_UPDATE.replace("{id}", id)}`, blobs)
    if (res.status === 200) {
        return res.data;
    } else {
        return [];
    }
}

export const createMessageGeneration = async (id) => {
    const res = await fetchApi.post(`${API_URL.AI_CREATE_GENERATION.replace("{id}", id)}`)
    return res.data
}

export const messageChatInitStreamGeneration = (id, text) => {
    return fetchApi.source(`${API_HOST}${API_URL.AI_STREAM_INIT_GENERATION.replace("{id}", id)}?text=${encodeURIComponent(text)}`)
}

export const messageChatStreamGeneration = (id, text) => {
    return fetchApi.source(`${API_HOST}${API_URL.AI_STREAM_GENERATION.replace("{id}", id)}?text=${encodeURIComponent(text)}`)
}

export const requestVerificationAI = (message) => {
    return new EventSourcePolyfill(`${API_HOST}${API_URL.VERIFICATION_STREAM}?prompt=${message}`, {
        heartbeatTimeout: 1200000,
    })
}

export const verificationList = async () => {
    return await instance.get(`${API_URL.VERIFICATION_LIST}`)
}

export const getVerification = async (id) => {
    return await instance.get(`${API_URL.VERIFICATION_DETAIL.replace("{id}", id)}`)
}

export const generateBenefitImage = async (benefitName, prompt) => {
    const res = await fetchApi.post(API_URL.AI_BENEFIT_IMAGE_GENERATION, {
        benefitName, prompt
    })
    if (res.status === 200) {
        return res.data;
    } else {
        return [];
    }
}

export const listAIAssistant = async () => {
    return await fetchApi.get(`${API_URL.LIST_ASSISTANT_AI}`)
}
export const getAIAssistant = async (id) => {
    return await fetchApi.get(`${API_URL.ASSISTANT_AI}?id=${id}`)
}

export const requestAIAssistant = (id, message) => {
    return fetchApi.source(`${API_HOST}${API_URL.ASSISTANT_AI_CHAT}?prompt=${encodeURIComponent(message)}${id ? `&id=${id}` : ''}`)
}

export const createAIAssistant = async (name) => {
    const res = await fetchApi.post(API_URL.ASSISTANT_AI, {
        name: name
    })
    return res.data
}

export const requestBusinessAI = (message) => {
    return fetchApi.source(`${API_HOST}${API_URL.BUSINESS_AI}?prompt=${encodeURIComponent(message)}`)
}

export const messageGeneration = async (messageObject, segmentType, benefitName, image) => {
    const formData = new FormData();
    formData.append("messageObject", messageObject);
    formData.append("segmentType", segmentType);
    formData.append("benefitName", benefitName);
    if (image) {
        formData.append("image", image);
    }

    const res = await fetchApi.multipart_post(API_URL.AI_GENERATION, formData, true)

    return res.data
}

export const messageSend = async (content, couponTitle, couponDescription, target, messageId) => {
    const res = await fetchApi.post(API_URL.AI_SEND, {
        content, couponTitle, couponDescription, target, messageId
    })

    return res.data
}

export const generateProject = async (eventName, coupons, prompt) => {
    const res = await fetchApi.post(API_URL.AI_PROJECT_GENERATE, {
        eventName, coupons, prompt
    }, true)

    return res.data
}

export const generateEvent = async (eventId, eventName, coupons, prompt) => {
    const res = await fetchApi.post(API_URL.AI_EVENT_GENERATE, {
        eventId, eventName, coupons, prompt
    })

    return res.data
}

export const generateSticker = async (sticker) => {
    return await fetchApi.post(API_URL.AI_STICKER_GENERATE, sticker, true)
}